import { Alert } from '@zillow/constellation-10';
import { useAuth } from '../AuthProvider';

type Props = {
  contactEmail: string;
};

const ContactEmailMismatchAlert = ({ contactEmail }: Props): JSX.Element | null => {
  const { user } = useAuth();

  if (user?.email?.toLowerCase() === contactEmail.toLowerCase()) return null;

  return (
    <Alert data-testid="ContactEmailMismatchAlertContainer" tone="warning">
      This contact email differs from the one associated with your Zillow account
    </Alert>
  );
};

export default ContactEmailMismatchAlert;
